var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 26.5,
    height: 26.5,
    rx: 1.25,
    stroke: "#6853C2",
    strokeOpacity: 0.8,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1327 10.4531H4.72656C4.325 10.4531 4 10.1277 4 9.72656C4 9.325 4.325 9 4.72656 9H23.1327C23.5338 9 23.8592 9.325 23.8592 9.72656C23.8592 10.1277 23.5338 10.4531 23.1327 10.4531Z",
    fill: "#6853C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7733 14.8125H4.72656C4.32501 14.8125 4 14.487 4 14.0859C4 13.6848 4.32501 13.3593 4.72656 13.3593H18.7733C19.1745 13.3593 19.4999 13.6848 19.4999 14.0859C19.4999 14.487 19.1745 14.8125 18.7733 14.8125Z",
    fill: "#6853C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3849 19.1718H4.72656C4.325 19.1718 4 18.8464 4 18.4452C4 18.0441 4.325 17.7187 4.72656 17.7187H13.3849C13.7865 17.7187 14.1115 18.0441 14.1115 18.4452C14.1115 18.8464 13.7865 19.1718 13.3849 19.1718Z",
    fill: "#6853C2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.73e1850fc6beeba38f725e864466826b.svg";
export { ForwardRef as ReactComponent };